import { Form, FormInstance, Input, InputNumber, Select, Space } from "antd";
import FormWrapper from "../../../../../components/UI/FormWrapper/FormWrapper";
import { useCallback, useEffect } from "react";
import { errorNotification } from "../../../../../components/UI/Toast/Toast";

interface Props {
  onNext?: VoidFunction;
  onCancel?: VoidFunction;
  form: FormInstance;
  readonly?: boolean;
  ghiDetails: any
}

const MemberDetailsForm: React.FC<Props> = ({ onNext, onCancel, form, readonly, ghiDetails }) => {
  const validateNext = useCallback(()=>{
    form.validateFields(['raised_for_uuid', 'personal_email', 'personal_phone'])
    .then((val) => {
      onNext?.()
    })
    .catch((err) => {
      errorNotification('Please check all fields before going ahead')
    });
  },[form, onNext]);
  const formComponent = <>
    <div className="card-title mb-32">Member Details</div>
    <Space direction="vertical" style={{width: '50%'}}>
      <Form.Item
        wrapperCol={{ span: 24 }}
        labelCol={{ span: 24 }}
        label="Who are you raising this claim for? (e.g., yourself, spouse, child, parent. Please write the name)"
        name="raised_for_uuid"
        rules={[{ required: true, message: 'Please select the claim recipient' }]}
      >
        <Select disabled={readonly}>
          {ghiDetails?.dependents?.map((item: any) => {
            return <Select.Option key={item?.uuid} value={item?.uuid}>{item?.full_name}</Select.Option>
          })}
        </Select>
      </Form.Item>
      <Form.Item
        wrapperCol={{ span: 24 }}
        labelCol={{ span: 24 }}
        label="What’s your personal email address?"
        name="personal_email"
        rules={[{ type: 'email', message: 'Please enter a valid email' }]}
      >
        <Input disabled={readonly} />
      </Form.Item>
      <Form.Item
        wrapperCol={{ span: 24 }}
        labelCol={{ span: 24 }}
        label="What’s your personal phone number?"
        name="personal_phone"
        rules={[
          // { required: true, message: "Please enter a mobile number!" },
          { pattern: RegExp('[6-9]{1}[0-9]{9}'), message: 'Please enter valid mobile number' },
          // { len: 10, message: 'Phone number should be 10 character long' },
        ]}
      >
        <InputNumber addonBefore='+91' disabled={readonly} style={{
          width: '100%'
        }} />
      </Form.Item>
    </Space></>;

  if (readonly) {
    return <>{formComponent}</>
  }

  return <FormWrapper primaryButton={{
    active: true,
    loading: false,
    disabled: false,
    title: 'Next',
    onClick: onNext ? validateNext : () => { }
  }} secondaryButton={{
    active: true,
    loading: false,
    disabled: false,
    title: 'Cancel',
    onClick: onCancel ? onCancel : () => { }
  }}>
    {formComponent}
  </FormWrapper>
};

export default MemberDetailsForm;
